export default __webpack_public_path__ + "static/media/logo.0a1703b2.svg";